import { URLs } from "../url";
import { getHeader } from "../headers";
import { ICreateUser } from "../../adminCore/userV2/types/types";

export const createUser = async (user: ICreateUser) => {
  try {
    const url = process.env.REACT_APP_HOST_API + URLs.createUser;
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(user),
      headers: getHeader(),
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUser = async (userId: string, user: ICreateUser) => {
  try {
    const url = process.env.REACT_APP_HOST_API + URLs.updateUser + "/" + userId;
    const response = await fetch(url, {
      method: "PATCH",
      body: JSON.stringify(user),
      headers: getHeader(),
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateUserRoles = async (userId: string, roles: string[]) => {
  try {
    const url = process.env.REACT_APP_HOST_API + URLs.updateUserRol;
    const response = await fetch(url, {
      method: "PUT",
      body: JSON.stringify({
        id: userId,
        roles: roles,
      }),
      headers: getHeader(),
    });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
